import { render } from "./S97867.vue?vue&type=template&id=860a08c6"
const script = {}
script.render = render

export default script